// extracted by mini-css-extract-plugin
module.exports = {"animateOnHover":"animateOnHover"};